// NOTE: `Guestrides` is defined in @hopdrive/sdk-configs/definitions but is not re-exported from
// the package's top-level index, so the effective_config read mirrors the minimal shape locally.
type GuestridesConfig = { guest_portal_enabled?: boolean };

/** A rooftop as far as this read needs it: the inheritance-merged config. */
export interface RooftopWithConfig {
  effective_config?: unknown;
}

/**
 * Whether the rooftop's guest self-service portal is enabled: the presence condition for the
 * Share Code action, which generates a link to that portal.
 */
export function readGuestPortalEnabled(rooftop: RooftopWithConfig | null | undefined): boolean {
  return (
    (rooftop?.effective_config as { guestrides?: GuestridesConfig } | undefined)?.guestrides?.guest_portal_enabled ===
    true
  );
}
